
import { Component, Vue } from "vue-property-decorator";
const Config = (require("../public/setting") as any).Config;
import { GetSystemMsg, GetClientInfo } from "@/request/common";
@Component({})
export default class App extends Vue {
  private isFullscreen = false;
  private showFullscreenPrompt = false;

  private created() {
    // 首先恢复用户信息
    this.$store.dispatch('initUserInfo');
    
    // 验证token有效性
    this.validateToken();
    
    // 然后处理localStorage的状态恢复（如果有的话）
    let state = localStorage.getItem("state");
    if (state) {
      try {
        const localState = JSON.parse(state);
        // 只恢复systemInfo，不覆盖用户信息
        if (localState.systemInfo) {
          this.$store.commit("updateSystemInfo", localState.systemInfo);
        }
        localStorage.removeItem("state");
      } catch (error) {
        console.error('恢复localStorage状态失败:', error);
        localStorage.removeItem("state");
      }
    }
  }

  private async validateToken() {
    const token = this.$store.getters.accessToken;
    const isLoggedIn = this.$store.getters.isLoggedIn;
    const userInfo = this.$store.getters.userInfo;
    const userId = userInfo && (userInfo.user_id || userInfo.user);
    if (token && isLoggedIn && userId) {
      console.log('验证token有效性...');
      try {
        // 用GetClientInfo接口验证token
        const params = { params: { user_id: userId } };
        await GetClientInfo(this, params);
        console.log('Token验证成功');
      } catch (error) {
        console.warn('Token验证失败，清除用户信息:', error);
        this.$store.commit('clearUserInfo');
      }
    } else {
      console.log('未找到有效token，用户未登录');
    }
  }

  private mounted() {
    // 保证页面刷新时store的值不丢失
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("state", JSON.stringify(this.$store.state));
    });

    // 监听全屏状态变化
    // document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    // document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    // document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    // document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);

    // // 延迟显示全屏提示（给页面一些加载时间）
    // setTimeout(() => {
    //   this.showFullscreenPrompt = true;
    // }, 1000);
    if (Config.ID) {
      const params: any = {
        params: {
          name: Config.ID,
        },
      };
      // 使用 Vant 的 loading
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      GetSystemMsg(this, params)
        .then((res: any) => {
          this.$toast.clear();
          let obj: any = { ...res.data, ...Config };
          // 修改项目名称
          document.title = obj.name;
          // 修改项目 icon
          let link: any = document.querySelector("link[rel='icon']");
          if (link) {
            link.href = obj.logo;
          } else {
            var newLink = document.createElement("link");
            newLink.rel = "icon";
            newLink.href = obj.logo;
            newLink.type = "image/x-icon";
            document.head.appendChild(newLink);
          }
          this.$store.commit("updateSystemInfo", obj);
        })
        .catch(() => {
          this.$toast.clear();
        });
    } else {
      let obj: any = { ...Config.SYSTEM_MSG, ...Config };
      // 修改项目名称
      document.title = obj.name;
      // 修改项目 icon
      let link: any = document.querySelector("link[rel='icon']");
      if (link) {
        link.href = obj.logo;
      } else {
        var newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = obj.logo;
        newLink.type = "image/x-icon";
        document.head.appendChild(newLink);
      }
      this.$store.commit("updateSystemInfo", obj);
    }
  }
  beforeDestroy() {
    window.removeEventListener("beforeunload", () => {
      localStorage.setItem("state", JSON.stringify(this.$store.state));
    });

    // 移除全屏事件监听器
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
    

  }

  // 全屏切换方法
  private toggleFullscreen() {
    if (!document.fullscreenElement) {
      this.enterFullscreen();
    } else {
      this.exitFullscreen();
    }
  }

  // 进入全屏
  private enterFullscreen() {
    // 隐藏全屏提示
    this.showFullscreenPrompt = false;
    
    // 尝试进入全屏
    try {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if ((document.documentElement as any).webkitRequestFullscreen) {
        (document.documentElement as any).webkitRequestFullscreen();
      } else if ((document.documentElement as any).mozRequestFullScreen) {
        (document.documentElement as any).mozRequestFullScreen();
      } else if ((document.documentElement as any).msRequestFullscreen) {
        (document.documentElement as any).msRequestFullscreen();
      }
    } catch (error) {
      console.log('全屏请求失败:', error);
      // 如果失败，延迟重试
      setTimeout(() => {
        this.enterFullscreen();
      }, 1000);
    }
  }

  // 退出全屏
  private exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  }

  // 处理全屏状态变化
  private handleFullscreenChange() {
    this.isFullscreen = !!(
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).mozFullScreenElement ||
      (document as any).msFullscreenElement
    );
  }

  // 跳过全屏
  private skipFullscreen() {
    this.showFullscreenPrompt = false;
  }
}
